import qs from 'qs';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import type { EventFeedbackOptions } from 'features/events';

export const useFeedbackOptions = (): EventFeedbackOptions => {
  const navigate = useNavigate();
  const location = useLocation();

  return useMemo(() => {
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (typeof query.feedback === 'string' && typeof query.eventId === 'string') {
      return {
        eventId: query.eventId,
        feedback: true,
        async onFinish() {
          delete query.feedback;
          delete query.eventId;
          await navigate({ pathname: location.pathname, search: qs.stringify(query) }, { replace: true });
        },
      };
    }

    return {
      feedback: false,
    };
  }, [location.search, location.pathname, navigate]);
};
